<template>
  <!-- Quotation定制化服务-小计 -->
  <div class="packageWrap">
    <div class="packageLeft">
      <p class="fs14 fwb" v-if="businessType == 'COMPREHENSIVE_CUSTOMIZED'">
        {{ $t("enroll.quotation.comprehensiveTitle") }}
      </p>
      <p class="fs14 fwb" v-if="businessType == 'FUND_ADMIN_CUSTOMIZED'">
        {{ $t("enroll.quotation.fundAdminTitle") }}
      </p>
      <p>
        <span class="fs20 fwb black00 vam">{{ priceCurrencyFormat(quotationPart.subTotalPrice, billingCurrency) }}</span>
        <span class="ml6 fs14 fwb blackD8 vam">({{ quotationPart.subTotalDesp }})</span>
      </p>
    </div>
    <div class="packageRight">
      <div class="fdr details">
        <div class="mr20">
          <!-- 套餐包含： -->
          <p class="fs12 fwb">
            {{ $t("creation.comboInclude") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="son in quotationPart.itemList" :key="`son-${son.id}`">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ son.title }}
              <span>({{ priceCurrencyFormat(serviceChargeCalculation(son.amount, son.thirdPartyFee, son.otherFee), billingCurrency) }})</span>
              <info-popover placement="top" :content="`${son.startDate} ~ ${son.endDate}`" iconClass="ml2 fs13 blackD8" v-if="son.startDate && son.endDate" />
            </li>
          </ul>
        </div>
        <!-- 第三方费用 -->
        <div class="mr20">
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            {{ $t("creation.priceInclude") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="part in mergeSameAttrList(quotationPart.itemList, 'noteForThirdParty', 'thirdPartyFee')" :key="`part-${part.id}`">
              <span class="mr2" v-if="part.noteForThirdParty">- {{ part.noteForThirdParty }}</span>
              <span v-if="$isNumberLike(part.thirdPartyFee)">({{ priceCurrencyFormat(part.thirdPartyFee, billingCurrency) }})</span>
            </li>
          </ul>
        </div>
        <!-- 其他费用 -->
        <div>
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            {{ $t("creation.otherExpenses") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="other in mergeSameAttrList(quotationPart.itemList, 'noteForOther', 'otherFee')" :key="`other-${other.id}`">
              <span class="mr2" v-if="other.noteForOther">- {{ other.noteForOther }}</span>
              <span v-if="$isNumberLike(other.otherFee)">({{ priceCurrencyFormat(other.otherFee, billingCurrency) }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatMixin from "@/mixins/formatMixin";
import priceCountMixin from "@/mixins/priceCountMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin, priceCountMixin],
  props: {
    businessType: {
      type: String,
      default: () => "",
    },
    quotationPart: {
      type: Object,
      default: () => {},
    },
    billingCurrency: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  display: flex;
  width: 100%;
  padding: 16px;
  background-color: #fdf6ec;

  .packageLeft {
    padding-right: 16px;
    max-width: 250px;
  }

  .packageRight {
    padding-left: 16px;
    border-left: 1px solid #e4e7ed;
  }
}
</style>
